/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ElementsGroupReference,
    ElementsGroupReferenceFromJSON,
    ElementsGroupReferenceFromJSONTyped,
    ElementsGroupReferenceToJSON,
    ElementsUserReference,
    ElementsUserReferenceFromJSON,
    ElementsUserReferenceFromJSONTyped,
    ElementsUserReferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface WorkspacePermissionPartialUpdate
 */
export interface WorkspacePermissionPartialUpdate {
    /**
     * 
     * @type {ElementsUserReference}
     * @memberof WorkspacePermissionPartialUpdate
     */
    user?: ElementsUserReference;
    /**
     * 
     * @type {ElementsGroupReference}
     * @memberof WorkspacePermissionPartialUpdate
     */
    group?: ElementsGroupReference;
    /**
     * 
     * @type {boolean}
     * @memberof WorkspacePermissionPartialUpdate
     */
    readOnly?: boolean;
    /**
     * 
     * @type {number}
     * @memberof WorkspacePermissionPartialUpdate
     */
    workspace?: number;
}

export function WorkspacePermissionPartialUpdateFromJSON(json: any): WorkspacePermissionPartialUpdate {
    return WorkspacePermissionPartialUpdateFromJSONTyped(json, false);
}

export function WorkspacePermissionPartialUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkspacePermissionPartialUpdate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : ElementsUserReferenceFromJSON(json['user']),
        'group': !exists(json, 'group') ? undefined : ElementsGroupReferenceFromJSON(json['group']),
        'readOnly': !exists(json, 'read_only') ? undefined : json['read_only'],
        'workspace': !exists(json, 'workspace') ? undefined : json['workspace'],
    };
}

export function WorkspacePermissionPartialUpdateToJSON(value?: WorkspacePermissionPartialUpdate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': ElementsUserReferenceToJSON(value.user),
        'group': ElementsGroupReferenceToJSON(value.group),
        'read_only': value.readOnly,
        'workspace': value.workspace,
    };
}


